export const ruleTemplates = [
    `input%class%[type=%type%]::placeholder {
        %placeholder%
    }`,
    `input%class%[type=%type%]:focus::placeholder {
        visibility: hidden;
    }`,
];
